import FiltersUtils from '../../mixins/FiltersUtils';

import Filters from '../../components/Filters';
import HeaderNav from '../../components/HeaderNav';

import Profile from './Profile';

export default {
  name: 'Map',
  components: { HeaderNav, Profile, Filters },
  mixins: [FiltersUtils],
  data() {
    return {
      testTourNumbers: window.location.href.includes('test_tour_numbers=true'),
      search: '',
      artistSelected: [],
      markers: [],
      markersPartner: [],
      map: null,
      mapLat: 30.281,
      mapLng: -97.703,
      mapZoom: 12.5,
      mapStyle: {
        disableDefaultUI: true,
        streetViewControl: false,
        fullscreenControl: false,
        clickableIcons: false,
        zoom: 12.5,
        minZoom: 11,
        maxZoom: 20,
        styles: [
          {
            elementType: 'geometry',
            stylers: [
              {
                color: '#f5f5f5'
              }
            ]
          },
          {
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#616161'
              }
            ]
          },
          {
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#f5f5f5'
              }
            ]
          },
          {
            featureType: 'administrative.land_parcel',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#bdbdbd'
              }
            ]
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
              {
                color: '#eeeeee'
              }
            ]
          },
          {
            featureType: 'poi',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#757575'
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [
              {
                color: '#e5e5e5'
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#9e9e9e'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
              {
                color: '#ffffff'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#000000'
              },
              {
                saturation: -10
              },
              {
                lightness: 50
              },
              {
                weight: 0.5
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'labels.icon',
            stylers: [
              {
                color: '#000000'
              }
            ]
          },
          {
            featureType: 'road.arterial',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#757575'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [
              {
                color: '#dadada'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#000000'
              },
              {
                weight: 0.5
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#000000'
              },
              {
                visibility: 'off'
              },
              {
                weight: 4
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#616161'
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#9e9e9e'
              }
            ]
          },
          {
            featureType: 'transit.line',
            elementType: 'geometry',
            stylers: [
              {
                color: '#e5e5e5'
              }
            ]
          },
          {
            featureType: 'transit.station',
            elementType: 'geometry',
            stylers: [
              {
                color: '#eeeeee'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
              {
                color: '#c9c9c9'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#9e9e9e'
              }
            ]
          }
        ]
      },
      mapStyleCluster: [
        {
          width: 52,
          height: 74,
          url: require('../../assets/img/pin-group.svg'),
          backgroundPosition: '0, 14px',
          fontFamily: 'epilogue, sans-serif',
          textColor: '#191856',
          textSize: 15,
        },
      ],
      currentLocation: null,
      directionsActive: [],
      directionsService: null,
      directionsDisplay: null,
    };
  },
  computed: {
    currentPositionIcon() {
      return require('../../assets/img/icon-current-position.svg');
    }
  },
  methods: {
    generateMarkers() {
      this.markers.splice(0, this.markers.length);
      let markers = [];
      this.artists.forEach((artist) => {
        if (artist.coordinates) {
          markers.push(this.createMarker(artist.coordinates.split(',')[0], artist.coordinates.split(',')[1], artist.coordinates));
        }
      });
      markers = _.uniqBy(markers, 'pos');
      markers.forEach((marker) => {
        marker.artists = this.artists.filter((artist) => {
          return artist.coordinates && (artist.coordinates.indexOf(marker.position.lat) > -1 && artist.coordinates.indexOf(marker.position.lng) > -1);
        });

        if (this.testTourNumbers) {
          delete marker.icon;
          marker.label.text = marker.artists[0].tour_number.toString();
          if (marker.artists.length > 1) {
            marker.label.text += `-${marker.artists.at(-1).tour_number.toString()}`;
          }
          marker.label.color = 'black';
          marker.label.fontWeight = 'bold';
        } else {
          if (marker.artists.length > 1) {
            marker.icon.url = require('../../assets/img/pin-cluster.svg');
            marker.label.text = marker.artists.length.toString();
          }
        }

        this.markers.push(marker);
      });
    },
    async getPartners() {
      const bpResponse = await fetch(`${this.$root.api_url}getPartners`);
      let partnersData = await bpResponse.json();
      partnersData.forEach(partner => {
        if (partner.coordinates) {
          this.markersPartner.push(this.createPartnerMarker(partner.coordinates.split(',')[0], partner.coordinates.split(',')[1], partner.coordinates, partner));
        }
      })
    },
    createMarker: (lat, lng, pos, partner) => {
      return {
        pos: pos,
        position: {
          lat: +lat,
          lng: +lng,
        },
        label: {
          text: ' ',
          fontFamily: 'epilogue, sans-serif',
          color: 'black',
          fontSize: '12px',
          fontWeight: 'bold',
        },
        icon: {
          url: require('../../assets/img/pin.svg'),
          labelOrigin: {x: 30, y: 12}
        },
        artists: [],
        partner: partner,
      }
    },
    createPartnerMarker: (lat, lng, pos, partner) => {
      return {
        pos: pos,
        position: {
          lat: +lat,
          lng: +lng,
        },
        label: {
          text: ' ',
          fontFamily: 'epilogue, sans-serif',
          color: 'white',
          fontSize: '12px',
        },
        icon: {
          url: require('../../assets/img/pin-partner.svg'),
          labelOrigin: {x: 30, y: 12}
        },
        artists: [],
        partner: partner,
      }
    },
    clusterCalculator(markers) {
      let markerStyle = 1;
      let count = 0;

      markers.forEach((marker) => {
        if (marker.label.text && !isNaN(marker.label.text)) {
          count += +(marker.label.text);
        }
      });

      if (!count) {
        count = markers.length;
      }

      return {
        text: count,
        index: markerStyle,
      };
    },
    artistMarkerClick(marker) {
      if (marker.partner) {
        this.artistSelected = marker.partner;
      } else {
        this.artistSelected = marker.artists;
      }

      this.openProfile();
    },
    artistClusterClick(cluster) {
      // Pan and zoom into cluster.
      this.map.panTo({ lat: cluster.center_.lat(), lng: cluster.center_.lng() });
      this.map.setZoom(this.map.zoom + 1);
    },
    mapShowKeyboard() {
      this.closeProfile();
      this.showKeyboard();
    },
    mapOpenFilters() {
      this.openFilters();

      setTimeout(() => {
        this.closeProfile();
      }, 500);
    },
    openProfile() {
      this.$refs.profile.open();
    },
    closeProfile() {
      this.$refs.profile.close();
    },
    getCurrentLocation() {
      let location = new google.maps.LatLng(this.$root.currentPosition[0], this.$root.currentPosition[1]);

      if (!this.currentLocation) {
        this.currentLocation = new google.maps.Marker({
          position: location,
          map: this.map,
          icon: this.currentPositionIcon,
        });
      } else {
        this.currentLocation.setPosition(location);
      }
    },
    centerCurrentLocation() {
      this.map.panTo(this.currentLocation.position);
    },
    directionsCancel() {
      this.directionsDisplay.setMap(null);
      this.directionsActive = [];
    },
    directionsApp() {
      let locations = this.directionsActive.map(location => {
        return encodeURIComponent(location);
      });
      let start = locations.shift();
      let end = locations.shift();
      let url = '';

      if (this.$root.app) {
        url = 'comgooglemapsurl://?saddr=' + start + '&daddr=' + end;
      } else {
        url = 'https://www.google.com/maps/?saddr=' + start + '&daddr=' + end;
      }

      // if (locations.length) url += '+to:' + locations.join('+to:');

      this.$root.openBrowser(url);
    },
    getDirections(artists) {
      artists = _.uniqBy(artists, 'pos');
      this.directionsCancel();
      let start = new google.maps.LatLng(this.$root.currentPosition[0], this.$root.currentPosition[1]);
      let waypoints = [];
      let lastDesination;

      this.directionsActive.push(start.lat() + ',' + start.lng());

      artists = artists.map((artist) => {
        return {
          lat: artist.coordinates.split(',')[0],
          lng: artist.coordinates.split(',')[1],
          distance: this.calculateDistance(this.$root.currentPosition[0], this.$root.currentPosition[1], artist.coordinates.split(',')[0], artist.coordinates.split(',')[1]),
          address: `${artist.tour_address} ${artist.tour_address_2} ${artist.tour_city} ${artist.tour_zip}`,
        }
      });

      if (artists.length > 1) {
        // Multiple routes
        artists.sort(function(a, b) {
          return a.distance - b.distance;
        });

        lastDesination = artists.pop();

        artists.forEach((artist) => {
          waypoints.push({
            location: new google.maps.LatLng(artist.lat, artist.lng),
            stopover: true,
          });
          this.directionsActive.push(artist.address);
        });
      } else {
        // Single route
        lastDesination = artists[0];
      }

      this.directionsActive.push(lastDesination.address);

      let request = {
        origin: start,
        destination: new google.maps.LatLng(lastDesination.lat, lastDesination.lng),
        waypoints: waypoints,
        travelMode: google.maps.TravelMode.WALKING
      };

      this.directionsDisplay.setMap(this.map);
      this.directionsService.route(request, (response, status) => {
        if (status == google.maps.DirectionsStatus.OK) {
          this.directionsDisplay.setDirections(response);
        }
      });
    },
    calculateDistance(lat1, lon1, lat2, lon2, unit) {
      var radlat1 = Math.PI * lat1/180
      var radlat2 = Math.PI * lat2/180
      var radlon1 = Math.PI * lon1/180
      var radlon2 = Math.PI * lon2/180
      var theta = lon1-lon2
      var radtheta = Math.PI * theta/180
      var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      dist = Math.acos(dist)
      dist = dist * 180/Math.PI
      dist = dist * 60 * 1.1515
      if (unit=='K') { dist = dist * 1.609344 }
      if (unit=='N') { dist = dist * 0.8684 }
      return dist
    },
  },
  watch: {
    artists() {
      this.generateMarkers();
    }
  },
  mounted() {
    if (!this.testTourNumbers) this.getPartners();
    this.$refs.mapRef.$mapPromise.then(map => {
      this.map = map;
      this.getCurrentLocation();
      this.directionsService = new google.maps.DirectionsService();
      this.directionsDisplay = new google.maps.DirectionsRenderer();
      setInterval(this.getCurrentLocation, 5000);
    });
  },
  activated() {
    this.generateMarkers();
    document.body.classList.add('page-map');

    // Get directions if 'planRoute' in URL
    this.$refs.mapRef.$mapPromise.then(map => {
      if (this.$route.query.planRoute) {
        this.getDirections(this.$root.artists.filter((artist) => {
          return artist.isFavorite;
        }));
      }
    });
  },
  deactivated() {
    document.body.classList.remove('page-map');
  }
};



// WEBPACK FOOTER //
// ./src/pages/Map/Map.js